import {
  logout,
  loginByUsername,
  getRole,
  getHallInfo,
  getType,
  getUserInfo,
  loginLogAdd,
} from '@/api/userApi'
import ls from '@/utils/localStorage'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { encryption } from '@/utils/util'

const state = {
  token: getToken(),
  userData: ls.get('userData') || {},
  mainBodyType: ls.get('mainBodyType') || {},
  permissions: ls.get('permissions') || [],
  firstLogin: ls.get('firstLogin') || false,
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_MAINBODYTYPE: (state, mainBodyType) => {
    state.mainBodyType = mainBodyType
  },
  SET_USERINFO: (state, userData) => {
    state.userData = userData
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_FIRST_LOGIN: (state, firstLogin) => {
    state.firstLogin = firstLogin
  },
}

const actions = {
  // 根据用户名登录
  LoginByUsername({ state, commit }, userData) {
    const user = encryption({
      data: userData,
      key: 'pigxpigxpigxpigx',
      param: ['password'],
    })
    return new Promise((resolve, reject) => {
      loginByUsername(
        user.username,
        user.password,
        user.device_type,
        user.code,
        user.randomStr
      )
        .then(async (response) => {
          const data = response.access_token
          const userData = response.user_info
          commit('SET_TOKEN', data)
          commit('SET_USERINFO', userData)
          setToken(data)
          ls.set('userData', userData)

          loginLogAdd({ source: 1 })

          getUserInfo()
            .then((res) => {
              const resData = res.data || {}
              ls.set('firstLogin', resData.firstLogin)
              commit('SET_FIRST_LOGIN', resData.firstLogin)
              const userData = ls.get('userData')
              userData.roleDesc = resData.roleDesc
              commit('SET_USERINFO', userData)
              ls.set('userData', userData)
              ls.set('comOrganization', {
                ...res.data.comOrganization,
                status: res.data?.comOrganization?.status || 'O',
              })
              resolve(data)
            })
            .catch(() => {
              reject()
            })
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 根据云平台的token登录
  LoginToken({ commit }, token) {
    commit('SET_TOKEN', token)
    setToken(token)
    return new Promise((resolve, reject) => {
      getHallInfo()
        .then((response) => {
          const userData = {
            username: response.data.username,
          }
          commit('SET_USERINFO', userData)
          // setToken(data);
          ls.set('userData', userData)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 查询用户信息, 只取是否初次登录，其他用户信息用的登录接口的
  GetUserInfo({ state, commit }) {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then((res) => {
          const resData = res.data || {}
          ls.set('firstLogin', resData.firstLogin)
          commit('SET_FIRST_LOGIN', resData.firstLogin)
          const userData = ls.get('userData')
          userData.roleDesc = resData.roleDesc
          commit('SET_USERINFO', userData)
          ls.set('userData', userData)
          ls.set('comOrganization', {
            ...res.data?.comOrganization,
            status: res.data?.comOrganization?.status || 'O',
          })
          resolve(data)
        })
        .catch(() => {
          reject()
        })
    })
  },
  // 查询用户信息
  GetRole({ state, commit }) {
    return new Promise((resolve, reject) => {
      getRole()
        .then((res) => {
          const data = res || {}
          const userData = Object.assign(state.userData, data)
          commit('SET_USERINFO', userData)
          commit('SET_PERMISSIONS', data.data || [])
          resolve(data)
        })
        .catch(() => {
          reject()
        })
    })
  },
  // 判断是周六福还是年轻空间
  GetType({ state, commit }) {
    return new Promise((resolve, reject) => {
      getType()
        .then((res) => {
          const data = res || []
          commit('SET_MAINBODYTYPE', data.data || [])
          ls.set('mainBodyType', data.data)
          resolve(data)
        })
        .catch(() => {
          reject()
        })
    })
  },
  // 登出
  LogOut({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('SET_TOKEN', '')
          commit('SET_USERINFO', {})
          commit('SET_PERMISSIONS', [])
          ls.remove('userData')
          removeToken()
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 注销session
  FedLogOut({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_USERINFO', {})
      commit('SET_PERMISSIONS', [])
      ls.remove('userData')
      removeToken()
      resolve()
    })
  },
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      ls.remove('userData')
      removeToken()
      resolve()
    })
  },
}
export default {
  state,
  mutations,
  actions,
}
